import React, { Component } from 'react'
import { connect } from 'react-redux'
import ForcePostSample from '../samples/ForcePostSample'
import { makeForcePost } from '../../../actions/transactionsActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _BASIC_TRANSACTIONS, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    status_check: ["mpgReq.SetStatusCheck(status_check);", "mpgReq.setStatusCheck(status_check);", "$mpgHttpPost = new mpgHttpsPostStatus\n($store_id,$api_token,$status,$mpgRequest);"],
    order_ID: ["forcepost.SetOrderId(order_id);", "forcepost.setOrderId(order_id);", "'order_id'=>$order_id"],
    amount: ["forcepost.SetAmount(amount);", "forcepost.setAmount(amount);", "'amount'=>$amount"],
    credit_card_number: ["forcepost.SetPan(pan);", "forcepost.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["forcepost.SetExpdate(expiry_date);", "forcepost.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    authorization_code: ["forcepost.SetAuthCode(auth_code);;", "forcepost.setAuthCode(auth_code);", "'auth_code'=>$auth_code"],
    electronic_commerce_indicator: ["forcepost.SetCryptType(crypt);", "forcepost.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    customer_ID: ["forcepost.SetCustId(cust_id);", "forcepost.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["forcepost.SetDynamicDescriptor(dynamic_descriptor);", "forcepost.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
}

export class ForcePost extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakeForcePostPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _BASIC_TRANSACTIONS, orderId: newOrderId });
        const { storeId, apiToken, orderId, pan, expdate, amount } = this.props;
        const forcePostRequest = { storeId, apiToken, orderId, pan, expdate, amount };
        this.props.makeForcePost(forcePostRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Force Post</h3>
                <ForcePostSample />
                <div className="requestButton" onClick={() => this.onMakeForcePostPress()}>
                    Force Post Request
                </div> 
            </div>
        )
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Force Post</b></span>
                <p style={{marginTop: '3vh'}}>Retrieves the locked funds and prepares them for settlement into the merchant’s account.</p>
                <p>Used when a merchant obtains the authorization number directly from the issuer by a third-party authorization method (such as by phone).</p>
                
                <div className='thingsToConsider'>
                    <b>Things to Consider: </b>
                    <ul>
                        <li>This transaction is an independent completion where the original Pre-Authorization transaction was not processed via the same Moneris Gateway merchant account.</li>
                        <li>It is not required for the transaction that you are submitting to have been processed via the Moneris Gateway. However, a credit card number, expiry date and original authorization number are required.</li>
                        <li>Force Post transactions are not supported for UnionPay</li>
                    </ul>
                </div>

                <p><b>Force Post transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>ForcePost forcepost = new ForcePost();</code>
                    case _JAVA:
                        return <code>ForcePost forcepost = new ForcePost();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’forcepost', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Force Post transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(forcepost);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(forcepost);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Optional connection object field</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>status check</td>
                        <td><i>Boolean</i><br /><br />true/false</td>
                        <td><code>{CODES.status_check[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>Force Post transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>amount</td>
                        <td><i>String</i><br /><br />10-character decimal<br />Up to 7 digits (dollars) +<br />decimal point (.) + 2 digits<br />(cents) after the decimal<br />point</td>
                        <td><code>{CODES.amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br />(YYMM format)</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>authorization code</td>
                        <td><i>String</i><br /><br />8-character alphanumeric</td>
                        <td><code>{CODES.authorization_code[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>Force Post transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric</td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount } = state.transactions.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeForcePost, updateOrderId})(ForcePost)
